import { ValidateJSModel, LocationModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModel from '../location';

interface LocationAddressModel {
  street: LocationModel['street']
  street2: LocationModel['street2']
  city: LocationModel['city']
  state: LocationModel['state']
  country: LocationModel['country']
  zipcode: LocationModel['zipcode']
  apoFpoDpoPostcode?: LocationModel['apoFpoDpoPostcode'],
  isMilitaryDiplomaticAddress?: LocationModel['isMilitaryDiplomaticAddress'],
  militaryDiplomaticInstallationName?: LocationModel['militaryDiplomaticInstallationName'],
  militaryInstallationNameNotApplicable?: LocationModel['militaryInstallationNameNotApplicable'],
  militaryDiplomaticInstallationNameExplanation?: LocationModel['militaryDiplomaticInstallationNameExplanation'],
}

const locationAddressModelValidator: ValidateJSModel<LocationAddressModel> = {
  street: locationModel.street as ValidateJSModelAttribute<LocationAddressModel, 'street'>,
  street2: locationModel.street2 as ValidateJSModelAttribute<LocationAddressModel, 'street2'>,
  city: locationModel.city as ValidateJSModelAttribute<LocationAddressModel, 'city'>,
  state: locationModel.state as ValidateJSModelAttribute<LocationAddressModel, 'state'>,
  zipcode: locationModel.zipcode as ValidateJSModelAttribute<LocationAddressModel, 'zipcode'>,
  country: locationModel.country as ValidateJSModelAttribute<LocationAddressModel, 'country'>,
  apoFpoDpoPostcode: locationModel.apoFpoDpoPostcode as ValidateJSModelAttribute<LocationAddressModel, 'apoFpoDpoPostcode'>,
  isMilitaryDiplomaticAddress: locationModel.isMilitaryDiplomaticAddress as ValidateJSModelAttribute<LocationAddressModel, 'isMilitaryDiplomaticAddress'>,
  militaryDiplomaticInstallationName: locationModel.militaryDiplomaticInstallationName as ValidateJSModelAttribute<LocationAddressModel, 'militaryDiplomaticInstallationName'>,
  militaryInstallationNameNotApplicable: locationModel.militaryInstallationNameNotApplicable as ValidateJSModelAttribute<LocationAddressModel, 'militaryInstallationNameNotApplicable'>,
  militaryDiplomaticInstallationNameExplanation: locationModel.militaryDiplomaticInstallationNameExplanation as ValidateJSModelAttribute<LocationAddressModel, 'militaryDiplomaticInstallationNameExplanation'>,
};

export default locationAddressModelValidator;
